import React from "react";
import Statistics from "components/statistics";
import "./about.scss";

const About = ({ language, hideStatistics }) => {
  const { selected, languageData } = language;
  return (
    <div className="summary">
      <div className="summary-container">
        <div className="summary-content">
          <div className="summary-title">
            {languageData[selected].newhome.about.header}
          </div>
          <div className="summary-desc">
            {languageData[selected].newhome.about.subheader}
          </div>
        </div>
        <div className={`summary-stats ${hideStatistics ? "hide" : ""}`}>
          <Statistics data={getSummaryStats(languageData[selected])} />
        </div>
      </div>
    </div>
  );
};

function getSummaryStats(selectedLanguageData) {
  const stats = [
    {
      name: selectedLanguageData.newhome.stats.users.label,
      value: selectedLanguageData.newhome.stats.users.count,
    },
    {
      name: selectedLanguageData.newhome.stats.cities.label,
      value: selectedLanguageData.newhome.stats.cities.count,
    },
  ];
  return stats;
}
export default About;
